import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Typography, Radio } from 'antd';
import { ProjectDto } from '@/core';
import { TableCard } from './TableCard';
import { TableTypesEnum, useFilteredTablesByType } from './hooks';
import { ErrorCard } from '@/components';
import classes from './TableCardsList.module.scss';

type PropsType = {
  projectData: ProjectDto;
  isTableWithoutColumns: boolean;
  isErrorNotification: boolean;
  isTablesTabValid: boolean;
};

export const TableCardsList = ({
  projectData,
  isTableWithoutColumns,
  isErrorNotification,
  isTablesTabValid,
}: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const [editedCardsIds, setEditedCardsIds] = useState<string[]>([]);
  const [filterValue, setFilterValue] = useState(TableTypesEnum.All);
  const { filteredTables, getItemsQuantityByFilter } = useFilteredTablesByType(
    projectData.tables,
    filterValue,
  );

  const handleClickEdit = (id: string) => setEditedCardsIds((prev) => [...prev, id]);
  const handleStopEditCard = (id: string) =>
    setEditedCardsIds((prev) => prev.filter((editedCardId) => editedCardId !== id));

  return (
    <div className={classes.cardsList}>
      <Radio.Group buttonStyle="solid" value={filterValue} onChange={(e) => setFilterValue(e.target.value)}>
        <Radio.Button value={TableTypesEnum.All}>
          {t('addTables.all')} <span className={classes.quantityOfItems}>({projectData.tables.length})</span>
        </Radio.Button>
        <Radio.Button value={TableTypesEnum.Main}>
          {t('addTables.main')}{' '}
          <span className={classes.quantityOfItems}>({getItemsQuantityByFilter(TableTypesEnum.Main)})</span>
        </Radio.Button>
        <Radio.Button value={TableTypesEnum.Summary}>
          {t('addTables.summary')}{' '}
          <span className={classes.quantityOfItems}>
            ({getItemsQuantityByFilter(TableTypesEnum.Summary)})
          </span>
        </Radio.Button>
      </Radio.Group>
      {(projectData.isCompleted && !isTablesTabValid) || isErrorNotification ? (
        <ErrorCard text={t('addTables.invalidPage')} />
      ) : null}
      {isTableWithoutColumns ? <ErrorCard text={t('addTables.emptyTable')} /> : null}
      {filteredTables?.length ? (
        <>
          <Row className={classes.cardsListTitle}>
            <Col xs={6} md={3}>
              <Typography.Text>{t('addTables.type')}</Typography.Text>
            </Col>
            <Col span={8}>
              <Typography.Text>{t('addTables.name')}</Typography.Text>
            </Col>
            <Col xs={10} md={13}>
              <Typography.Text>{t('addTables.description')}</Typography.Text>
            </Col>
          </Row>
          {filteredTables.map((table) => (
            <TableCard
              key={table.id}
              onClickMenuEdit={() => handleClickEdit(table.id)}
              isEdit={editedCardsIds.includes(table.id)}
              stopEditCard={() => handleStopEditCard(table.id)}
              projectData={projectData}
              {...table}
            />
          ))}
        </>
      ) : null}
    </div>
  );
};
